import { AxiosRequestConfig } from 'axios'

export interface CohortApiParams {
  endDate: string
  storeId?: number
}

const getCohortAnalysis = (params: CohortApiParams): AxiosRequestConfig => ({
  url: '/dashboard/cohort-analysis',
  method: 'GET',
  params,
})

export { getCohortAnalysis }
